export const CREATOR_CLIENT_CLASS_NAME = 'CreatorClient'

export const CREATOR_CLIENT_KEY = {

  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',

  STARTED_AT: 'startedAt',
  ENDED_AT: 'endedAt',

  // Associations
  CREATOR_ID: 'creatorId',
  CLIENT_ID: 'clientId',
  CHAT_ID: 'chatId',

  // Associations
  CREATORS: 'creators',
  CLIENTS: 'clients',
  CHAT: 'chat'

}

export const CREATOR_CLIENT_PRIVATE_KEYS = []

export const CREATOR_CLIENT_SCOPE = {

  /**
   * Only returns the public attributes of a `Settings`.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: CREATOR_CLIENT_PRIVATE_KEYS
    }
  }

}

export const CREATOR_CLIENT_AUDIT = {
  CREATED: 'CreatorClient Created',
  CLIENT_ACCEPTED_INVITATION: 'CreatorClient Client Accepted Invitation',
  HIRED: 'CreatorClient Hired',
  DELETED: 'CreatorClient Deleted',
  UPDATED: 'CreatorClient Updated'
}

export const CREATOR_CLIENT_AUDIT_CLASS_NAME = 'CreatorClientAudit'

export const CREATOR_CLIENT_ASSOCIATIONS = [
  CREATOR_CLIENT_KEY.CREATORS,
  CREATOR_CLIENT_KEY.CLIENTS,
  CREATOR_CLIENT_KEY.CHAT
]
